module.exports = __webpack_public_path__ + "static/media/trigger_soundi 4-2-Audio 1.df58e974.mp3";